import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const MaterialSwitch = styled(Switch)(({ theme }) => ({}));
